(function () {
  if (window.OelTabs) {
    window.OelTabs.initAll();
    return;
  }
  var MOBILE_QUERY = '(max-width: 767px)';
  var SLIDE_MS = 500;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-oel-tabs-item]'));
  }

  function slideDown(target, duration) {
    duration = duration || SLIDE_MS;
    target.removeAttribute('hidden');
    target.style.removeProperty('display');
    target.style.display = 'block';
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(function () {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      target.style.removeProperty('transition-timing-function');
    }, duration);
  }

  function slideUp(target, duration, onDone) {
    duration = duration || SLIDE_MS;
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = '0';
    target.style.paddingTop = '0';
    target.style.paddingBottom = '0';
    target.style.marginTop = '0';
    target.style.marginBottom = '0';
    window.setTimeout(function () {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      target.style.removeProperty('transition-timing-function');
      if (onDone) onDone();
    }, duration);
  }

  function checkInViewportAndScrollTo(trigger) {
    if (!trigger) return;
    var rect = trigger.getBoundingClientRect();
    var windowScrollY =
      (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    var inViewport =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth);

    if (!inViewport) {
      window.scrollTo({
        top: windowScrollY + rect.top,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  function setPanelOpen(panel, open, animate) {
    if (!panel) return;
    if (open) {
      var wasClosed = panel.hasAttribute('hidden') || !panel.classList.contains('is-open');
      panel.removeAttribute('hidden');
      panel.classList.add('is-open');
      if (animate && wasClosed) {
        slideDown(panel);
      } else if (!animate) {
        panel.style.display = '';
      }
      return;
    }

    if (animate && panel.classList.contains('is-open') && window.getComputedStyle(panel).display !== 'none') {
      slideUp(panel, SLIDE_MS, function () {
        panel.classList.remove('is-open');
        panel.setAttribute('hidden', 'hidden');
      });
      return;
    }

    panel.classList.remove('is-open');
    panel.setAttribute('hidden', 'hidden');
    panel.style.display = '';
  }

  function setSelected(root, index, options) {
    var settings = options || {};
    var items = getItems(root);
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-oel-tabs-tab]'));
    var currentIndex = parseInt(root.getAttribute('data-oel-tabs-index') || '0', 10);
    var item = items[index];
    var trigger = item && item.querySelector('[data-oel-tabs-accordion]');
    var animate = isMobile();

    if (isMobile() && settings.toggleOnMobile && index === currentIndex) {
      var currentPanel = item && item.querySelector('[data-oel-tabs-panel]');
      if (currentPanel && currentPanel.classList.contains('is-open')) {
        closeAll(root, animate);
        root.setAttribute('data-oel-tabs-index', '-1');
        return;
      }
    }

    root.setAttribute('data-oel-tabs-index', String(index));

    items.forEach(function (tabItem, i) {
      var open = i === index;
      var panel = tabItem.querySelector('[data-oel-tabs-panel]');
      var accordion = tabItem.querySelector('[data-oel-tabs-accordion]');
      var tab = tabs[i];

      setPanelOpen(panel, open, animate);

      if (accordion) {
        accordion.classList.toggle('accordion-is-open', open);
        accordion.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      if (tab) {
        tab.classList.toggle('current', open);
        tab.setAttribute('aria-selected', open ? 'true' : 'false');
        tab.setAttribute('tabindex', open ? '0' : '-1');
      }
    });

    if (animate && trigger && index !== currentIndex) {
      window.setTimeout(function () {
        checkInViewportAndScrollTo(trigger);
      }, 600);
    }
  }

  function closeAll(root, animate) {
    getItems(root).forEach(function (item) {
      var panel = item.querySelector('[data-oel-tabs-panel]');
      var accordion = item.querySelector('[data-oel-tabs-accordion]');

      setPanelOpen(panel, false, animate);

      if (accordion) {
        accordion.classList.remove('accordion-is-open');
        accordion.setAttribute('aria-expanded', 'false');
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-oel-tabs-tab]'), function (tab) {
      tab.classList.remove('current');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });
  }

  function bindRoot(root) {
    if (root.getAttribute('data-oel-tabs-ready') === 'true') return;
    root.setAttribute('data-oel-tabs-ready', 'true');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-oel-tabs-tab]'));
    var items = getItems(root);

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setSelected(root, index);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (nextIndex === index) return;
        event.preventDefault();
        setSelected(root, nextIndex);
        tabs[nextIndex].focus();
      });
    });

    items.forEach(function (item, index) {
      var accordion = item.querySelector('[data-oel-tabs-accordion]');
      if (!accordion) return;
      accordion.addEventListener('click', function () {
        setSelected(root, index, { toggleOnMobile: true });
      });
    });

    setSelected(root, 0);
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oel-tabs]'), bindRoot);
  }

  window.OelTabs = {
    initAll: initAll,
    select: setSelected
  };

  function syncVariantDescriptions(variantId) {
    document.querySelectorAll('[data-oel-oil-descriptions]').forEach(function (root) {
      var panels = root.querySelectorAll('[data-oel-description-variant]');
      var shown = false;

      panels.forEach(function (panel) {
        var match = panel.getAttribute('data-oel-description-variant') === String(variantId);
        panel.hidden = !match;
        if (match) {
          shown = true;
          var tabs = panel.querySelector('[data-oel-tabs]');
          if (tabs) setSelected(tabs, 0);
        }
      });

      root.hidden = panels.length > 0 ? !shown : root.hidden;
    });
  }

  document.addEventListener('theme:variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    syncVariantDescriptions(variant.id);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest('[data-oel-tabs-item]');
    var root = event.target.closest('[data-oel-tabs]');
    if (!item || !root) return;
    var index = getItems(root).indexOf(item);
    if (index >= 0) setSelected(root, index);
  });
})();
